const gridImagePrefix =
  "https://images.sonder.com/image/upload/c_fill,f_auto,q_auto:good,w_400";

export const citiesData = {
  amsterdam: {
    image: {
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Amsterdam.jpg`,
      alt: "Amsterdam hotel room with a view and desk.",
    },
    neighborhoodCount: 1,
    translateKey: "cities.names.amsterdam",
  },
  austin: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Austin.jpg`,
    },
    neighborhoodCount: 2,
    translateKey: "cities.names.austin",
  },
  barcelona: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Barcelona.jpg`,
    },
    neighborhoodCount: 4,
    translateKey: "cities.names.barcelona",
  },
  boston: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Boston.jpg`,
    },
    neighborhoodCount: 5,
    translateKey: "cities.names.boston",
  },
  cannes: {
    image: {
      alt: "Cannes city view",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Cannes.jpg`,
    },
    neighborhoodCount: 1,
    translateKey: "cities.names.cannes",
  },
  chicago: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Chicago.jpg`,
    },
    neighborhoodCount: 5,
    translateKey: "cities.names.chicago",
  },
  denver: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Denver.jpg`,
    },
    neighborhoodCount: 3,
    translateKey: "cities.names.denver",
  },
  detroit: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Detroit.jpg`,
    },
    neighborhoodCount: 1,
    translateKey: "cities.names.detroit",
  },
  dubai: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Dubai.jpg`,
    },
    neighborhoodCount: 3,
    translateKey: "cities.names.dubai",
  },
  dublin: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Dublin.jpg`,
    },
    neighborhoodCount: 3,
    translateKey: "cities.names.dublin",
  },
  edinburgh: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Edinburgh.jpg`,
    },
    neighborhoodCount: 1,
    translateKey: "cities.names.edinburgh",
  },
  florence: {
    image: {
      alt: "florence city",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/florence.jpg`,
    },
    neighborhoodCount: 1,
    translateKey: "cities.names.florence",
  },
  glasgow: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Glasgow.jpg`,
    },
    neighborhoodCount: 2,
    translateKey: "cities.names.glasgow",
  },
  london: {
    image: {
      url: `${gridImagePrefix}/catalina/homepage/city_grid/London.jpg`,
      alt: "Sonder London lobby",
    },
    neighborhoodCount: 15,
    translateKey: "cities.names.london",
  },
  los_angeles: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Los_Angeles.jpg`,
    },
    neighborhoodCount: 6,
    translateKey: "cities.names.los_angeles",
  },
  madrid: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Madrid.jpg`,
    },
    neighborhoodCount: 2,
    translateKey: "cities.names.madrid",
  },
  malaga: {
    image: {
      alt: "Malaga room",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Malaga.jpg`,
    },
    neighborhoodCount: 1,
    translateKey: "cities.names.malaga",
  },
  miami: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Miami.jpg`,
    },
    neighborhoodCount: 4,
    translateKey: "cities.names.miami",
  },
  milan: {
    image: {
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Milan.jpg`,
      alt: "Bed in hotel room with modern couch and desk",
    },
    neighborhoodCount: 2,
    translateKey: "cities.names.milan",
  },
  minneapolis: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Minneapolis.jpg`,
    },
    neighborhoodCount: 5,
    translateKey: "cities.names.minneapolis",
  },
  montreal: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Montreal.jpg`,
    },
    neighborhoodCount: 3,
    translateKey: "cities.names.montreal",
  },
  nashville: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Nashville.jpg`,
    },
    neighborhoodCount: 9,
    translateKey: "cities.names.nashville",
  },
  new_orleans: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/New_Orleans.jpg`,
    },
    neighborhoodCount: 9,
    translateKey: "cities.names.new_orleans",
  },
  new_york_city: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/New_York_City.jpg`,
    },
    featuredImage: {
      url: "https://images.sonder.com/image/upload/c_fill,f_auto,q_auto:eco,w_600/catalina/homepage/city_grid/New_York_City_-_Featured.png",
    },
    neighborhoodCount: 7,
    translateKey: "cities.names.new_york_city",
  },
  nice: {
    image: {
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Nice.jpg`,
      alt: "Bed in hotel room with modern bathroom and chair at breakfast table",
    },
    neighborhoodCount: 3,
    translateKey: "cities.names.nice",
  },
  orlando: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Orlando.jpg`,
    },
    neighborhoodCount: 3,
    translateKey: "cities.names.orlando",
  },
  ottawa: {
    image: {
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Ottawa.jpg`,
      alt: "Living room view of a rental in Ottawa, ON with a large blue couch, round wooden coffee table and orange accent chairs.",
    },
    neighborhoodCount: 2,
    translateKey: "cities.names.ottawa",
  },
  paris: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Paris.jpg`,
    },
    neighborhoodCount: 4,
    translateKey: "cities.names.paris",
  },
  philadelphia: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Philadelphia.jpg`,
    },
    neighborhoodCount: 9,
    translateKey: "cities.names.philadelphia",
  },
  phoenix: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Phoenix.jpg`,
    },
    neighborhoodCount: 4,
    translateKey: "cities.names.phoenix",
  },
  rome: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Rome.jpg`,
    },
    neighborhoodCount: 11,
    translateKey: "cities.names.rome",
  },
  rotterdam: {
    image: {
      alt: "A cityscape of Rotterdam",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Rotterdam.jpg`,
    },
    neighborhoodCount: 1,
    translateKey: "cities.names.rotterdam",
  },
  san_diego: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/San_Diego.jpg`,
    },
    neighborhoodCount: 2,
    translateKey: "cities.names.san_diego",
  },
  savannah: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Savannah.jpg`,
    },
    neighborhoodCount: 1,
    translateKey: "cities.names.savannah",
  },
  seattle: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Seattle.jpg`,
    },
    neighborhoodCount: 2,
    translateKey: "cities.names.seattle",
  },
  toronto: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Toronto.jpg`,
    },
    neighborhoodCount: 5,
    translateKey: "cities.names.toronto",
  },
  vancouver: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Vancouver.jpg`,
    },
    neighborhoodCount: 1,
    translateKey: "cities.names.vancouver",
  },
  washington_dc: {
    image: {
      alt: "",
      url: `${gridImagePrefix}/catalina/homepage/city_grid/Washington_DC.jpg`,
    },
    neighborhoodCount: 5,
    translateKey: "cities.names.washington_dc",
  },
};

export const cityCount = Object.keys(citiesData).length;
export const cityCountRounded = Math.floor(cityCount / 5) * 5;
export const countryCount = 8;

export const featured = [
  "london",
  "dubai",
  "new_york_city",
  "los_angeles",
  "montreal",
];

export const worldCities = [
  "dubai",
  "dublin",
  "edinburgh",
  "glasgow",
  "london",
  "montreal",
  "paris",
  "rome",
  "toronto",
];
